export default __webpack_public_path__ + "static/media/20191206_211356.10fb4549.jpg";